export const MIN_MS_BETWEEN_CONSECUTIVE_CALLS = 75;
